import { useState, useEffect, useCallback } from 'react'
import { emitDispatchEvent } from './utils/func'

const GlobalHooks = () => {
    let [isMask, setMask] = useState(false)
    let [isShowSelDiv, setisShowSelDiv] = useState(false)

    const addLister = useCallback(() => {
        window.addEventListener('message', function (msg) {
            console.log(msg)
            const {
                data
            } = msg
            if (data.type === "onMask") {
                setMask(!!data.mask)
                setisShowSelDiv(data.val)
            }
        })
    }, [])

    const setShowSelDiv = useCallback((flag: boolean) => {
        setisShowSelDiv(!!flag)
        const info = { 
            sign: 'isShowSelDiv',
            type: 'isShowSelDiv',
            val: flag
         }
        window.parent.postMessage(info, '*')
    }, [setisShowSelDiv])

    const rmLister = useCallback(() => {
    }, [])

    useEffect(() => {
        addLister()
        return rmLister
    }, [addLister, rmLister])

    // useEffect(() => {
    //     console.log(isShowSelDiv, isMask)
    //     const info = { 
    //         sign: 'isShowSelDiv',
    //         type: 'isShowSelDiv',
    //         val: isShowSelDiv
    //      }
    //     window.parent.postMessage(info, '*')
    // }, [isMask, isShowSelDiv])

    return {
        isMask,
        isShowSelDiv,
        setMask,
        setShowSelDiv,
        emitDispatchEvent
    }
}

export default GlobalHooks
